import { useState, useEffect } from 'react';

const useGeolocation = () => {
    const [location, setLocation] = useState({
        loaded: false,
        coordinates: { lat: "", lng: "" },
        error: null
    });

    useEffect(() => {
        let isMounted = true;

        // Geolocation options compatible across Chrome, Firefox, Safari, Edge
        const geoOptions = {
            enableHighAccuracy: false,   // false is more cross-browser reliable
            timeout: 10000,              // 10 seconds timeout
            maximumAge: 300000           // Accept cached positions up to 5 min old
        };

        const onSuccess = (position) => {
            if (!isMounted) return;
            setLocation({
                loaded: true,
                coordinates: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                },
                error: null
            });
        };

        const onError = (error) => {
            if (!isMounted) return;
            setLocation({
                loaded: true,
                coordinates: { lat: "", lng: "" },
                error: {
                    code: error.code,
                    message: error.message,
                },
            });
        };

        if (!("geolocation" in navigator)) {
            onError({ code: 0, message: "Geolocation not supported by this browser" });
            return;
        }

        const watchId = navigator.geolocation.getCurrentPosition(
            onSuccess,
            onError,
            geoOptions
        );

        return () => {
            isMounted = false;
        };
    }, []);

    return location;
};

export default useGeolocation;
